import React, { Component } from 'react'
import loadable from '@loadable/component'
import getVideoDetailInitialProps from '../public/getVideoDetailInitialProps'

const VideoDetail = loadable(() => import('../containers-m/VideoDetail'))

export default class VideoDetailPage extends Component {
    static async getInitialProps (context) {
        return getVideoDetailInitialProps(context, { includeRelated: false })
    }

    render () {
        return <VideoDetail {...this.props} />
    }
}
